var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14C9.28333 14 9.521 13.904 9.713 13.712C9.905 13.52 10.0007 13.2827 10 13C10 12.7167 9.904 12.4793 9.712 12.288C9.52 12.0967 9.28267 12.0007 9 12C8.71667 12 8.47933 12.096 8.288 12.288C8.09667 12.48 8.00067 12.7173 8 13C8 13.2833 8.096 13.521 8.288 13.713C8.48 13.905 8.71733 14.0007 9 14ZM8 10H10V4H8V10ZM5.25 18L0 12.75V5.25L5.25 0H12.75L18 5.25V12.75L12.75 18H5.25ZM6.1 16H11.9L16 11.9V6.1L11.9 2H6.1L2 6.1V11.9L6.1 16Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.35e9cced4dd2572f548e9dac21efc7bc.svg";
export { ForwardRef as ReactComponent };